import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { EpdkConfirmationDialogModule } from '../../ui/confirmation-dialog/confirmation-dialog.module';

@NgModule({
  imports: [
    CommonModule,

    // Angular Material.
    MatDialogModule,

    EpdkConfirmationDialogModule
  ]
})
export class ConfirmationDialogServiceModule { }
